import { haversineDistanceMetres } from '@/utils/geoDistance';
import { Inspection } from '@/types/Inspection.type';
import { DEFAULT_FACTORY_DISTANCE_THRESHOLD_M } from '@/utils/factoryVerificationConfig.util';

export type DeviceLocation = {
  latitude: number;
  longitude: number;
  accuracyMetres: number | null;
};

export function getFactoryRegisteredCoords(
  inspection: Inspection | null
): { lat: number; lng: number } | null {
  const lat = inspection?.factory?.address?.latitude;
  const lng = inspection?.factory?.address?.longitude;
  if (lat == null || lng == null) {
    return null;
  }
  return { lat, lng };
}

export function isDeviceLocationVerified(
  deviceLocation: DeviceLocation | null,
  registeredCoords: { lat: number; lng: number } | null,
  distanceThresholdM: number = DEFAULT_FACTORY_DISTANCE_THRESHOLD_M
): boolean {
  if (!registeredCoords || !deviceLocation) {
    return false;
  }
  const distanceM = haversineDistanceMetres(
    deviceLocation.latitude,
    deviceLocation.longitude,
    registeredCoords.lat,
    registeredCoords.lng
  );
  console.log(`distanceM ${distanceM} <= ${distanceThresholdM}`);
  return distanceM <= distanceThresholdM;
}
